import { Container, Grid, CircularProgress } from "@mui/material";

const AppAlertBar = ({ description }) => {
  return (
    <section className="AppAlertBar">
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <div className="AppAlertBarInner">
              <p className="fontSize18 marginRight10">{description || ""}</p>
              <CircularProgress size={24} className="loaderCircle" />
            </div>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
};

export default AppAlertBar;
